export const getLevelColor = (infoData, currentLevelId) =>
  infoData?.find((info) => info.levelId === currentLevelId)?.color || {};

export const getLevelAsset = (infoData, currentLevelId) =>
  infoData?.find((info) => info.levelId === currentLevelId)?.asset || {};
